class BadgeTooltip extends HTMLElement {
  constructor() {
    super();
    this.tooltip = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.tooltip = this.querySelector('.badge-tooltip__content');
    if (!this.tooltip) return;

    // Desktop hover events
    this.addEventListener('mouseenter', this.show.bind(this));
    this.addEventListener('mouseleave', this.hide.bind(this));

    // Mobile/touch tap events
    this.addEventListener('click', this.toggle.bind(this));

    // Close when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));

    // Close on escape key
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
    document.removeEventListener('keydown', this.handleKeydown.bind(this));
  }

  show() {
    if (window.matchMedia('(hover: hover)').matches) {
      this.tooltip.classList.add('is-visible');
      this.isOpen = true;
      this.positionTooltip();
    }
  }

  hide() {
    if (window.matchMedia('(hover: hover)').matches) {
      this.tooltip.classList.remove('is-visible');
      this.isOpen = false;
    }
  }

  toggle(event) {
    // Only handle tap on touch devices
    if (!window.matchMedia('(hover: none)').matches) return;
    
    event.stopPropagation();
    
    if (this.isOpen) {
      this.tooltip.classList.remove('is-visible');
      this.isOpen = false;
    } else {
      // Close any other open tooltips first
      document.querySelectorAll('badge-tooltip .badge-tooltip__content.is-visible').forEach(el => {
        el.classList.remove('is-visible');
      });
      
      this.tooltip.classList.add('is-visible');
      this.isOpen = true;
      this.positionTooltip();
    }
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target) && this.isOpen) {
      this.tooltip.classList.remove('is-visible');
      this.isOpen = false;
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.tooltip.classList.remove('is-visible');
      this.isOpen = false;
    }
  }

  positionTooltip() {
    // Reset position first
    this.tooltip.style.left = '';
    this.tooltip.style.right = '';
    this.tooltip.style.transform = '';

    const tooltipRect = this.tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const padding = 16;

    // Check if tooltip overflows on the right
    if (tooltipRect.right > viewportWidth - padding) {
      const overflow = tooltipRect.right - (viewportWidth - padding);
      this.tooltip.style.transform = `translateX(calc(-50% - ${overflow}px))`;
    }

    // Check if tooltip overflows on the left
    if (tooltipRect.left < padding) {
      const overflow = padding - tooltipRect.left;
      this.tooltip.style.transform = `translateX(calc(-50% + ${overflow}px))`;
    }
  }
}

customElements.define('badge-tooltip', BadgeTooltip);
